import React, { useState } from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import type { StoreHeader } from '@flipdish/api-client-typescript';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { getTranslate, Translate } from 'react-localize-redux';

import type { AssignedVoucher } from '../../types/assignedVouchers.types';
import CustomerDetailsTable from './CustomerDetailsTable';
import CustomerDetailsVouchersTable from './CustomerDetailsVouchersTable';

type OuterProps = {
  isFlipdishStaff: boolean;
  stores: StoreHeader[];
  storeFilter?: number[];
  customer?: { assignedVouchers?: AssignedVoucher[] } | null;
  assignedVouchersLoading?: boolean;
};

type Props = OuterProps;

const InnerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: theme.spacing(2),
}));

const CustomerDetailsTabs = ({
  isFlipdishStaff,
  stores,
  storeFilter,
  customer,
  assignedVouchersLoading,
}: Props) => {
  const [tabIndex, setTabIndex] = useState<number>(0);

  const translate = useAppSelector((state) => getTranslate(state));

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Box>
      <InnerBox pb={2}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          aria-label={translate('Customer_details_tabs') as string}
        >
          <Tab label={<Translate id="Orders" />} />
          <Tab label={<Translate id="Vouchers" />} />
        </Tabs>
      </InnerBox>

      {tabIndex === 0 && (
        <CustomerDetailsTable
          stores={stores}
          storeFilter={storeFilter}
          isFlipdishStaff={isFlipdishStaff}
        />
      )}

      {tabIndex === 1 && (
        <CustomerDetailsVouchersTable
          assignedVouchers={customer?.assignedVouchers || []}
          isLoading={assignedVouchersLoading}
        />
      )}
    </Box>
  );
};

export default CustomerDetailsTabs;
